var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tkBadge",class:{ '-removable': _vm.removable },style:({
    'max-width': _vm.maxWidth ? `${_vm.maxWidth}px` : undefined,
    'padding-top': `${_vm.paddingTop}px`,
    'padding-bottom': `${_vm.paddingBottom}px`,
    'font-weight': _vm.fontWeight,
  }),on:{"click":function($event){_vm.removable && _vm.$emit('remove')}}},[(_vm.removable)?_c('tk-cross-mark',{staticClass:"tkBadge_crossmark",attrs:{"width":2,"length":7}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }